import { assert, Test } from "oc-e2e-testrunner";
import { assertSegmentIstLückenlosGefüllt, resetArrangement } from "./utils";

export default {
  name: "TestFormPfostenVerschiebung",
};

export const testStrecke: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.update3d();
  assert.equals(1, agt.segmente.length);
  assert.equals(breite, agt.segmente[0].breite);
  agt.fillIndividuellSegmentsWithElements();
  assertSegmentIstLückenlosGefüllt(agt.segmente[0]);
};

export const testRechteck: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 3;
  agt.grundriss.setStandardForm("Rechteck", [breite, breite]);
  agt.update3d();
  assert.equals(4, agt.segmente.length);
  agt.fillIndividuellSegmentsWithElements();
  assertSegmentIstLückenlosGefüllt(agt.segmente[0]);
};

export const testLForm: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 3;
  agt.grundriss.setStandardForm("LForm", [breite, breite, breite, breite]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  assert.equals(6, agt.segmente.length);
  assertSegmentIstLückenlosGefüllt(agt.segmente[0]);
};
